import { jsx as _jsx } from "react/jsx-runtime";
// import hooks
import { useTheme } from "@mui/material/styles";
import Spacer from "../../../../../components/atoms/Spacer/index.js";
export const AppBarPushContentDownComponent = ({ position, defaultHeight = "56px", ...props }) => {
    const theme = useTheme();
    if (["relative", "static"].includes(position ?? "")) {
        return null;
    }
    return (_jsx(Spacer, { "data-testid": "AppBarPushContentDown", ...props, direction: "vertical", px: theme.mixins.toolbar.minHeight ?? defaultHeight }));
};
export default AppBarPushContentDownComponent;
